import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, PAGE_SIZES) {
	const states = [
		{
			name: 'parameterEvolution',
			parent: 'analysis',
			url: '/parameterEvolutions?page&sort&size&road&campaign',
			component: 'parameterEvolutionSearch',
			data: {
				viewAuthorities: ['PARAMETEREVOLUTION_READ', 'PARAMETEREVOLUTION_WRITE'],
				editAuthorities: ['PARAMETEREVOLUTION_WRITE']
			},
			params: {
				page:     { value: 0,          type: 'int', squash: true, dynamic: true },
				size:     { value: 10,         type: 'int', squash: true, dynamic: true },
				sort:     { value: 'name,asc',             squash: true, dynamic: true },
				road:     { type: 'int',                   squash: true, dynamic: true },
				campaign: { type: 'int',                   squash: true, dynamic: true }
			},
			resolve: {
				/* @ngInject */
				allOrganizations: Organization => Organization.query({ sort: 'name,asc' }).$promise,
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign => Campaign.query({ sort: 'name,asc', empty: false }).$promise
			}
		},
		{
			name: 'parameterEvolution.detail',
			url: '/{id}',
			component: 'parameterEvolutionDetail',
			resolve: {
				/* @ngInject */
				entity: (ParameterEvolution, $transition$, entityInjector) =>
					entityInjector(ParameterEvolution, $transition$.params().id, {}),
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign => Campaign.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allConstantSets: ConstantSet => ConstantSet.query({ sort: 'name,asc' }).$promise,
				/* @ngInject */
				allGrowthRates: GrowthRate => GrowthRate.query({ query: '' }).$promise
			}
		},
		{
			name: 'parameterEvolution.chartLine',
			url: '/{id}/resultChartLine?direction&lanes&metric&headYear&tailYear&milestones',
			component: 'parameterEvolutionResultChartLine',
			params: {
				direction:  { value: null,  squash: true, dynamic: true },
				lanes:      { array: true, value: [], type: 'int', squash: true, dynamic: true },
				metric:     { value: null,  squash: true, dynamic: true },
				headYear:   { value: null,  type: 'int', squash: true, dynamic: true },
				tailYear:   { value: null,  type: 'int', squash: true, dynamic: true },
				milestones: { array: true, value: [], squash: true, dynamic: true }
			},
			resolve: {
				/* @ngInject */
				allMetrics: Metadata => Metadata.getMetrics({ measurement: 'KPI', view: 'ANALYSIS' }),
				/* @ngInject */
				entity: (ParameterEvolution, $transition$, entityInjector) =>
					entityInjector(ParameterEvolution, $transition$.params().id, {}),
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign => Campaign.query({ sort: 'name,asc', empty: false }).$promise
			}
		}
	];

	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
